import { TContract, TContractsResponse, TUserGroupInvitation, TUserGroupInvitationsResponse } from "@bsm/graphql"
import { GraphQLQueryClass } from "@bsm/component"

export class OrganizationEmployeesQuery implements GraphQLQueryClass<
  TContractsResponse,
  TResponse
> {
  public queryKey: string = "App.BSM.RH.Organization.Employees.Query";

  public gql: string = `
        query OrganizationEmployeesQuery(
            $page: Float
            $pageSize: Float
            $sort: [TFilterSort!]
            $key: String
        ) {
            contracts(filter: {
                key: $key,
                page: $page,
                pageSize: $pageSize,
                sort: $sort,
                data: { isActive: true }
            }) {
            total
            data {
                id
                isActive
                user {
                    id
                    matricule
                    fullName
                    firstName
                    lastName
                    email
                    profilePicture {
                        id
                    }
                    department {
                        id
                        designation
                    }
                    isAdmin
                }
                jobPosition {
                    id
                    value
                }
                createdAt
                isEditable
            }
        }
      }
    `;

  variables?: any;

  constructor(variables?: any) {
    this.variables = variables;
  }

  mapFn(data: TResponse): TContractsResponse {
    return {
      total: data.contracts.total,
      data: data.contracts.data,
    };
  }
}

export type TResponse = {
    contracts: {
        total: number;
        data: Array<TContract>;
    };
};
